export const TOGGLE_INSTAGRAM_CHANNEL_REQUEST = 'TOGGLE_INSTAGRAM_CHANNEL_REQUEST'
export const TOGGLE_INSTAGRAM_CHANNEL_RESPONSE = 'TOGGLE_INSTAGRAM_CHANNEL_RESPONSE'
export const TOGGLE_INSTAGRAM_CHANNEL_ERROR = 'TOGGLE_INSTAGRAM_CHANNEL_ERROR'
